import { render, staticRenderFns } from "./StageTwo.vue?vue&type=template&id=1b20e545&scoped=true&"
import script from "./StageTwo.vue?vue&type=script&lang=js&"
export * from "./StageTwo.vue?vue&type=script&lang=js&"
import style0 from "./StageTwo.vue?vue&type=style&index=0&id=1b20e545&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b20e545",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
